import { ApolloError, QueryHookOptions, gql, useQuery } from '@apollo/client';

import { Server } from '../../apollo/types';
import { CoachDisabledByType, CoachUserType, GetCoachAccessInfoQuery, GetCoachAccessInfoQueryVariables } from './types';

export const GET_COACH_ACCESS_INFO = gql`
  query GetCoachAccessInfo($userId: String!, $userType: CoachUserType) {
    coachAccess(userId: $userId, userType: $userType) {
      userId
      userType
      canUpdateAccess
      enabled
      disabledReasons {
        disabledByType
      }
    }
  }
`;

interface GetCoachAccessInfoResponse {
  loading: boolean;
  error?: ApolloError;
  data?: GetCoachAccessInfoQuery;
  coachReleasedToClient: boolean;
}

export function useGetCoachAccess(
  clientUserShortId: string,
  queryOptions: Omit<
    QueryHookOptions<GetCoachAccessInfoQuery, GetCoachAccessInfoQueryVariables>,
    'variables' | 'context'
  > = {},
): GetCoachAccessInfoResponse {
  const { data, loading, error } = useQuery<GetCoachAccessInfoQuery, GetCoachAccessInfoQueryVariables>(
    GET_COACH_ACCESS_INFO,
    {
      ...queryOptions,
      variables: {
        userId: clientUserShortId,
        userType: CoachUserType.CLIENT_USER,
      },
      context: { server: Server.MONOLITH },
    },
  );

  return {
    data,
    loading,
    error,
    coachReleasedToClient: data?.coachAccess?.disabledReasons
      ? !data?.coachAccess?.disabledReasons?.some(
          (reason) => reason.disabledByType === CoachDisabledByType.NOT_RELEASED_TO_USER,
        )
      : false,
  };
}
